import { createApiSlice } from "@common";
import {
  CURD_ACCOUNT_TAGGING_BY_ID,
  CURD_CONTACT_TAG,
  CURD_CONTACT_TAGGING,
  CURD_CONTACT_TAGGING_BY_ID,
  CURD_CUSTOMER_TAGGING_BY_ID
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addContactTagging",
    method: "post",
    url: CURD_CONTACT_TAG,
    stateKey: "message",
  },
  {
    name: "addCustomerAccountContactTagging",
    method: "post",
    url: CURD_CONTACT_TAGGING,
    stateKey: "message",
  },
  {
    name: "getCustomerAccountContactTagging",
    method: "get",
    url: CURD_CONTACT_TAGGING_BY_ID,
    stateKey: "data",
  },
  {
    name: "getContactByCustomerId",
    method: "get",
    url: CURD_CONTACT_TAGGING_BY_ID,
    stateKey: "contactData",
  },
  {
    name: "getCustomerContactTagging",
    method: "get",
    url: CURD_CUSTOMER_TAGGING_BY_ID,
    stateKey: "data",
  },
  {
    name: "getAccountContactTagging",
    method: "get",
    url: CURD_ACCOUNT_TAGGING_BY_ID,
    stateKey: "data",
  },
  {
    name: "deleteContactTagging",
    method: "delete",
    url: CURD_CONTACT_TAGGING,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    contactData: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "contactTagging",
  apiConfig,
  customReducers,
);
const contactTaggingSlice = slice;
// Export the slice's reducer
export default contactTaggingSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addCustomerAccountContactTagging,
  getCustomerAccountContactTagging,
  getContactByCustomerId,
  deleteContactTagging,
  addContactTagging,
  getCustomerContactTagging,
  getAccountContactTagging,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
